import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { Router, RouterLink } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { project } from 'src/app/Models/BasicForms/project';
import { AddTask } from 'src/app/Models/BasicForms/addtask';
import { Dailymaster } from 'src/app/Models/BasicForms/Dailymaster';
import { DisabledTimeFn, NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { moduleMaster } from 'src/app/Models/BasicForms/moduleMaster';
import { featureMaster } from 'src/app/Models/BasicForms/featureMaster';
import { taskSubtaskMaster } from 'src/app/Models/BasicForms/taskSubtaskMaster';
import * as moment from 'moment';
import { PickTask } from 'src/app/Models/BasicForms/picktask';
import { AddSubtask } from 'src/app/Models/BasicForms/AddSubtask';
import { worklogM } from 'src/app/Models/BasicForms/worklogM';
import { ThrowStmt } from '@angular/compiler';
import { Addtasksubtaskmaster } from 'src/app/Models/BasicForms/addtasksubtaskmaster';
// import { Adworklogmaster } from 'src/app/Models/BasicForms/adworklogmaster';



@Component({
  selector: 'app-schedulelist',
  templateUrl: './schedulelist.component.html',
  styleUrls: ['./schedulelist.component.css']
})
export class SchedulelistComponent implements OnInit {
  @Input() multipleImages: any[];
  data: Dailymaster = new Dailymaster();
  data1: PickTask = new PickTask();
  data6: worklogM = new worklogM();
  data5: taskSubtaskMaster = new taskSubtaskMaster()
  data7: Addtasksubtaskmaster = new Addtasksubtaskmaster()
  // data8 : Adworklogmaster = new Adworklogmaster()

  data4: any[] = [];
  quoteItems: any[] = [];
  quotePhotos: any[] = [];
  itemsList: any[] = [];
  itemsList2: any[] = [];
  itemsList3: any[] = [];
  quoteItemsInclusions: any[] = [];
  allTermsConditons: any[] = [];
  // inclusiondata: QuotationItemInclusions = new QuotationItemInclusions();
  // inclusiondataList: QuotationItemInclusions[] = [];
  isSpinning = false
  isSpinninggg = false
  isShow = true
  visible = false
  visible2 = false
  visible1 = false
  expand: boolean = false
  customers = []
  drawerData1: AddTask = new AddTask();
  states = []
  banks = []
  // selectedBank: BankAccount = new BankAccount()
  Header = []
  Footer = []
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "ID";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
  columns: string[][] = [["PARENT_NAME", "Parent Name"], ["NAME", "Item Group Name"]];
  containers = []
  glass: boolean = true
  subjects = [];
  ENQUIRY_DATE: any = new Date();
  height: number;
  Width: number;
  totalsq: number = 0;
  VERSION = 1
  inputValue = ''
  isConfirmLoading = false;
  isConfirmLoading1 = false;
  isConfirmLoading2 = false;
  filteredOptions: string[] = [];
  filteredOptions2: string[] = [];
  filteredOptions3: string[] = [];
  data2: AddTask = new AddTask();
  address = ''
  quoteNo = 1;
  // loadingRecords = false;
  inclusionIndex = -1;
  inclusionMainIndex = -1;
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  fileURL1: File = null;
  imageSrc1: string;
  folderName = "Quotarton_file";
  uploadedAttachmentStr1: string;
  drawerVisible: boolean;
  drawerVisible1: boolean;
  visibles: boolean = false;
  drawerTitle1: string;
  percent: number
  isOk = true;
  Itemgrps = []
  Itemgrps1 = []
  drawerTitle: string;
  applicationId = Number(this.cookie.get('applicationId'));
  isVisible2 = false
  isVisible23 = false
  isVisible234 = false
  isCollapsed = false;
  isLogedIn = false;
  ADDSUB: boolean = false
  ADDSUB1: boolean = false
  userId = this.cookie.get('userId');
  roleId = Number(this.cookie.get('roleId'));
  level = Number(this.cookie.get('level'));
  menus = [];
  Date1 = new Date()
  empty: boolean = true
  USERNAME = this.cookie.get('userName');
  formatterPercent = (value: number): string => `${value} %`;
  parserPercent = (value: string): string => value.replace(' %', '');
  pageName: string = "";
  constructor(public api: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public router: Router, private message: NzNotificationService, private cookie: CookieService) { }
  @ViewChild('content', { static: false }) pdfTable: ElementRef;
  ngOnInit(): void {
    this.data = new Dailymaster();
    this.loadAllProjects1()
    this.data6.PROGRESS = 0

    this.api.getAllMappedProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1 and USER_ID=' + this.api.userId).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.isListLoading = false;

        this.projectList = projectData['data'];
      }

    }, err => {

    });
    // if(this.ENQUIRY_DATE==new Date()){
    //   this.ADDSUB=true
    // }else{
    //   this.ADDSUB=false
    // }
    // this.loadalltask()
    // this.api.getAllWorklogs(0, 0, '', '', '').subscribe(data => {
    //   
    //   this.loadingRecords = false;
    //   this.totalRecords = data['count'];
    //   this.worklogData = data['data'];

    //   }, err => {
    //     
    //     if (err['ok'] == false)
    //       this.notificationService.error("Server Not Found", "");
    //   });
    // this.loadallsubtask()
  }

  loadalltask() {
    this.api.getAllPickedtask(0, 0, '', '', '').subscribe(localName => {
      if (localName['code'] == 200) {
        this.Itemgrps = localName['data'];


      }

    }, err => {

    });
  }
  loadallsubtask() {
    this.api.getAllTaskSubtask(0, 0, '', '', ' AND FEATURE_ID = ' + this.featureid).subscribe(localName1 => {
      if (localName1['code'] == 200) {
        this.Itemgrps1 = localName1['data'];


      }

    }, err => {

    });
  }

  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;

    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";

    } catch (error) {
      sort = "";
    }

    var likeQuery = " ";

    if (this.searchText != "") {
      likeQuery = " AND (";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });

      likeQuery = likeQuery.substring(0, likeQuery.length - 2) + ')'
    }

    if (likeQuery)
      this.filterQuery = "AND APPLICATION_ID=" + this.applicationId + likeQuery;

    else
      this.filterQuery = "AND APPLICATION_ID=" + this.applicationId;

    this.api.getAllDailymaster(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {


      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];


    }, err => {

    });
  }
  close(): void {
    this.visible = false;
    this.inclusionIndex = -1;
    this.inclusionMainIndex = -1;
    // this.inclusiondat/a = new QuotationItemInclusions();
  }
  close2(): void {
    this.visible2 = false;
    this.inclusionIndex = -1;
    this.inclusionMainIndex = -1;

    // this.inclusiondata = new QuotationItemInclusions();
  }
  close1(): void {
    this.visible1 = false;
  }



  open(k): void {
    this.visible = true;
    this.inclusionIndex = k;
    // this.inclusiondata.QTY = this.quoteItems[k]['QTY']
  }
  open2(k): void {
    this.visible2 = true;
    this.inclusionIndex = k;
    // this.inclusiondata.QTY = this.quoteItems[k]['QTY']
  }

  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }



  open1(): void {
    this.visible1 = true;
  }
  add() {
    this.isShow = true;
    // this.quoteItems.push(new QuotationItem());
  }


  drawerClose1(): void {
    this.drawerVisible1 = false;
    this.loadAllProjects()
    // this.loadcustomers();
    // this.getLatestCustomers();
  }

  disabledStartDate2() {

    if (this.ENQUIRY_DATE != undefined) {

      return (current: Date): boolean =>

        differenceInCalendarDays(current, this.ENQUIRY_DATE) > 0;

      // ||

      // differenceInCalendarDays(current, this.ENQUIRY_DATE) < 0

    } else {

      // return (current: Date): boolean =>

      // differenceInCalendarDays(current,this.ENQUIRY_DATE) < 0;

    }

  }
  projectList: any[] = [];
  projectList1: any[] = [];
  lotofnames = []
  num = []
  namee: string
  dta: any
  idire = []
  isds = []
  tata: any
  Itemgrpssspush = []
  progresss: any
  loadAllProjects1() {
    this.projectList1 = [];

    this.dta = this.datePipe.transform(this.ENQUIRY_DATE, "yyyy-MM-dd");

    // this.isSpinning = true;
    this.api.getAllPickedtask(0, 0, '', 'desc', 'AND DATE = ' + "'" + this.dta + "'" + ' AND USER_ID = ' + this.api.userId).subscribe(projectData1 => {
      if (projectData1['code'] == 200) {
        if (projectData1['count'] == 0) {
          this.glass = false
        } else {
          this.glass = true
        }

        this.projectList1 = projectData1['data'];
        this.isSpinninggg = true
        // this.idire=[]
        for (let i = 0; i < this.projectList1.length; i++) {
          this.projectList1[i]['TASKS'] = []

          this.idire.push(projectData1['data'][i]['TASK_ID']);
          if (i + 1 == this.projectList1.length) {

            this.api.getAllTaskSubtask1(0, 0, '', '', ' AND PARENT_ID  in (' + this.idire.toString() + ')' + ' AND USER_ID = ' + this.api.userId, this.dta).subscribe(localName => {
              if (localName['code'] == 200) {
                this.Itemgrps = localName['data'];
                this.isSpinninggg = false

                // this.Itemgrps[m]['NAMES'] = []
                this.isds = []

                for (let j = 0; j < this.Itemgrps.length; j++) {
                  for (let k = 0; k < this.projectList1.length; k++) {
                    if (this.Itemgrps[j].PARENT_ID == this.projectList1[k].TASK_ID) {
                      this.projectList1[k]['TASKS'].push(this.Itemgrps[j]);

                    }
                  }
                }
              }

            }, err => {

            });
          }
        }
        this.api.getAllMappedProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1 and USER_ID=' + this.api.userId).subscribe(projectData => {
          if (projectData['code'] == 200) {
            this.isListLoading = false;

            this.projectList = projectData['data'];
          }

        }, err => {

        });


      }

    }, err => {

    });
  }
  cancel(): void {
    // this.nzMessageService.info('click cancel');
  }

  confirm(itemss): void {
    // this.nzMessageService.info('click confirm');
    if (itemss.ID) {
      this.api.deletepickedTask(itemss.ID).subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.loadingRecords = true;
          this.notificationService.success("Picked Task Deleted Successfully", "");
          this.loadAllProjects1()
        } else {
          this.notificationService.error("Failed to Delete Picked Task", "");
        }
      }, err => {
        if (err["ok"] == false) {
          this.notificationService.error("Server Not Found", "");
        }
      });
    }
  }
  loadAllProjects12(event) {


    this.projectList1 = [];

    this.disabledStartDate = (current: Date): boolean =>
      differenceInCalendarDays(current, event) > 0 || differenceInCalendarDays(current, event) < 0;
    this.ENQUIRY_DATE = this.datePipe.transform(this.ENQUIRY_DATE, "yyyy-MM-dd");
    this.tata = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    if (this.ENQUIRY_DATE < this.tata) {

      this.ADDSUB = true
    } else {
      this.ADDSUB = false
    }

    if (this.ENQUIRY_DATE > this.tata) {

      this.ADDSUB1 = true
    } else {
      this.ADDSUB1 = false
    }
    this.dta = this.datePipe.transform(this.ENQUIRY_DATE, "yyyy-MM-dd");

    // this.isSpinning = true;
    this.api.getAllPickedtask(0, 0, '', 'desc', 'AND DATE = ' + "'" + this.dta + "'" + ' AND USER_ID = ' + this.api.userId).subscribe(projectData1 => {
      if (projectData1['code'] == 200) {
        if (projectData1['count'] == 0) {
          this.glass = false
        } else {
          this.glass = true
        }

        this.projectList1 = projectData1['data'];
        this.isSpinninggg = true
        this.idire = []
        for (let i = 0; i < this.projectList1.length; i++) {
          this.projectList1[i]['TASKS'] = []

          this.idire.push(projectData1['data'][i]['TASK_ID']);
          if (i + 1 == this.projectList1.length) {

            this.api.getAllTaskSubtask1(0, 0, '', '', ' AND PARENT_ID  in (' + this.idire.toString() + ')' + ' AND USER_ID = ' + this.api.userId, this.dta).subscribe(localName => {
              if (localName['code'] == 200) {
                this.Itemgrps = localName['data'];
                this.isSpinninggg = false

                this.isds = []

                for (let j = 0; j < this.Itemgrps.length; j++) {
                  for (let k = 0; k < this.projectList1.length; k++) {
                    if (this.Itemgrps[j].PARENT_ID == this.projectList1[k].TASK_ID) {
                      this.projectList1[k]['TASKS'].push(this.Itemgrps[j]);

                    }
                  }
                }
              }
            }, err => {

            });
          }
        }
        this.api.getAllMappedProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1 and USER_ID=' + this.api.userId).subscribe(projectData => {
          if (projectData['code'] == 200) {
            this.isListLoading = false;

            this.projectList = projectData['data'];
          }

        }, err => {

        });



      }

    }, err => {

    });
  }
  getWorklogIDWise(typeID) {
    this.loadingRecords = true;
    let filterStr = " and TYPE_ID=" + typeID + ' AND USER_ID = ' + this.api.userId;

    this.api.getAllWorklogs(this.pageIndex, this.pageSize, 'ID', 'desc', filterStr).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.worklogData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
  edit1(items): void {
    // 

    this.drawerTitle1 = "Update Task";
    this.drawerData1 = Object.assign({}, items);
    this.drawerVisible1 = true;
  }

  addcustomer(data) {

    sessionStorage.setItem("into", data.ID)
    this.drawerTitle1 = "Add Task";
    this.drawerData1 = new AddTask();
    this.drawerVisible1 = true;
  }

  get closeCallback1() {
    return this.drawerClose1.bind(this);
  }

  handleCancel(): void {
    this.isVisible2 = false;
    this.isConfirmLoading2 = false;
    this.data1 = new PickTask();
    this.resetpickmodal()
  }
  handleCancel1(): void {
    this.isVisible23 = false;
    this.isConfirmLoading1 = false;
    this.SUBTASK = ''
    this.data5 = new taskSubtaskMaster()
  }
  handleCancel12(): void {
    this.isVisible234 = false;
    this.isConfirmLoading = false;
    this.data6 = new worklogM();
    this.worklogData1 = []
  }

  print() {
    this.reset();
    this.isVisible2 = true;

  }

  projectid: number
  moduleid: number
  featureid: number
  parenttaskid: number
  isd: number
  parentTaskList1: any
  assigneee
  print1(items2) {
    // this.reset();

    this.isd = items2.ID
    this.projectid = items2.PROJECT_ID
    this.moduleid = items2.SUBTASK_MODULE_ID
    this.featureid = items2.SUBTASK_FEATURE_ID
    this.parenttaskid = items2.TASK_ID
    this.isVisible23 = true;

    var asss = items2.TASK_ASSIGNEE_IDS.split(",");
    this.assigneee = [...new Set(asss)]

  }


  clickMe(itemss): void {
    this.data6 = Object.assign({}, itemss);
    this.visibles = false;
  }

  handleCancelForWorklog(): void {
    // this.notificationService.info('click cancel',"");
  }

  handleConfirmForWorklog(itemss: worklogM) {
    if (itemss.ID) {
      this.api.deleteWorklog(itemss.ID).subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.loadingRecords = true;
          this.notificationService.success("Worklog Deleted Successfully", "");
          this.api.getAllWorklogs(0, 0, '', '', ' AND TYPE_ID = ' + itemss.TYPE_ID + ' AND USER_ID = ' + this.api.userId).subscribe(data => {


            if (data['count'] == 0) {
              this.empty = false
              this.worklogData1 = []
            } else {
              this.empty = true
              this.worklogData1 = data['data'];

            }
            this.worklogData1 = [...[], ...this.worklogData1]
            this.loadingRecords = false;

            // 

          }, err => {

            if (err['ok'] == false)
              this.notificationService.error("Server Not Found", "");
          });
          // this.getWorklogIDWise(this.type, this.typeID);

        } else {
          this.notificationService.error("Failed to Delete Worklog", "");
        }

      }, err => {
        if (err["ok"] == false) {
          this.notificationService.error("Server Not Found", "");
        }
      });
    }
  }

  change(value: boolean): void {

  }
  taskid: number
  worklogData1 = []
  pro: number
  print21(items) {
    // this.reset();

    this.data6.PROGRESS = items.PROGRESS
    this.worklogData1 = []
    var dat = new Date()
    var newdate = this.datePipe.transform(dat, 'HH:mm:ss')


    this.data6.WORKED_DATETIME = new Date(this.datePipe.transform(this.ENQUIRY_DATE, 'yyyy-MM-dd') + "T" + newdate)
    this.isVisible234 = true;
    this.taskid = items.ID
    this.pro = items.PROJECT_ID
    this.api.getAllWorklogs(0, 0, '', '', ' AND TYPE_ID = ' + items.ID + ' AND USER_ID = ' + this.api.userId).subscribe(data => {


      if (data['count'] == 0) {
        this.empty = false
      } else {
        this.empty = true
      }
      this.loadingRecords = false;
      // this.totalRecords = data['count'];
      // if(data['count']!=0){
      //   this.data6.PROGRESS=data['data'][0]['PROGRESS']
      // }else{
      //   this.data6.PROGRESS=0
      // }

      this.worklogData1 = data['data'];
      // 

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });

  }
  onContentNameChange(event, items) {
    // this.data.TASK_CATEGORY_ID = this.data.TASK_CATEGORY_ID;
    // this.data.FEATURE_ID = this.data.FEATURE_ID;
    // this.data.PARENT_ID = this.data.PARENT_ID;
    // this.data.NAME = taskName;
    // this.data.DESCRIPTION = this.data.DESCRIPTION;
    // this.data.ESTIMATED_HOURS = 0;
    // this.data.ESTIMATED_MINUTES = 0;
    // this.data.ESTIMATED_SECONDS = 0;

    // this.data.ASSIGNEE_ID = this.data.ASSIGNEE_ID;

    // this.data.REPORTER_ID = this.data.REPORTER_ID;
    // this.data.PRIORITY = this.data.PRIORITY;

    // this.data.TIME_TRACKED = this.data.TIME_TRACKED;
    // this.data.STATUS = this.data.STATUS;

    // this.data.START_DATE = this.data.START_DATE;
    // this.data.END_DATE = this.data.END_DATE;

    // this.data.IS_CHILD = this.data.IS_CHILD;
    // this.data.DEPENDENT_TASK_ID = this.data.DEPENDENT_TASK_ID;

    // this.data.UPDATED_DATETIME = new Date();
    // this.data.UPDATED_DATETIME = this.datePipe.transform(this.data.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

    // this.data.TAGS = this.data.TAGS;
    // this.data.PROGRESS = this.data.PROGRESS;
    // this.data.IS_ACTIVE = true;


    this.data5.NAME = event
    this.data5 = items

    this.api.updateTaskSubtask(this.data5).subscribe(successCode => {


      if (successCode['code'] == "200") {
        this.notificationService.success("Task Updated Successfully", "");
        // this.logtext = 'Update & Close - Task Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
        // this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        //   if (successCode['code'] == "200") {
        //     
        //   }
        //   else {
        //     
        //   }
        // });

        // this.drawerClose();

      } else {
        this.notificationService.error("Failed to Update Task", "");
        // this.logtext = 'Update & Close - Task Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Master ]";
        // this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        //   if (successCode['code'] == "200") {
        //     
        //   }
        //   else {
        //     
        //   }
        // });
      }

    }, err => {


      if (err["ok"] == false) {
        this.notificationService.error("Server Not Found", "");
      }
    });

  }

  radiodropChange(event, items) {
    this.data5.PRIORITY = event
    this.data5 = items
    this.api.updateTaskSubtask(this.data5).subscribe(successCode => {


      if (successCode['code'] == "200") {
        this.notificationService.success("Task Updated Successfully", "");

        this.loadAllProjects1()
        this.isSpinning = false;
        // this.drawerClose();

      } else {
        this.notificationService.error("Failed to Update Task", "");

      }

    })
    // 
    // 
  }

  SUBTASK: string
  MASTER_ID: number
  SUBTASK_ID: number
  DATE_TIME: any
  CLIENT_ID: number
  handleaddsubtask(addNew): void {
    this.isOk = true;

    // this.message.error('Please Enter Item Group Name', '');
    // this.idprint.nativeElement.click();

    if (
      this.SUBTASK == undefined &&
      this.data5.PRIORITY == null

    ) {
      this.isOk = false;
      this.message.error('Please Fill All Required Information', '');

    } else if (this.SUBTASK == undefined || this.SUBTASK.trim() == '') {
      this.isOk = false
      this.message.error('Please Enter Sub-Task', '')

    } else if (this.data5.PRIORITY == null || this.data5.PRIORITY == undefined) {

      this.isOk = false;
      this.message.error('Please Select Priority', '');
    }

    if (this.isOk) {
      this.isConfirmLoading1 = true;
      // this.data5.USER_ID = this.api.userId
      this.data5.TASK_CATEGORY_ID = 0
      this.data5.FEATURE_ID = this.featureid
      this.data5.PARENT_ID = this.parenttaskid
      this.data5.NAME = this.SUBTASK;
      this.data5.DESCRIPTION = ""
      this.data5.ESTIMATED_HOURS = 0
      this.data5.ESTIMATED_MINUTES = 0
      this.data5.ESTIMATED_SECONDS = 0
      this.data5.USER_ID = this.api.userId

      // this.data5.PRIORITY = this.SUBTASK_PRIORITY;

      this.data5.TIME_TRACKED = new Date();
      this.data5.TIME_TRACKED = this.datePipe.transform(this.data5.TIME_TRACKED, "HH:mm") + ":00";

      this.data5.STATUS = "P";

      this.data5.START_DATE = this.datePipe.transform(this.SUBTASK_START_DATE, "yyyy-MM-dd");
      this.data5.END_DATE = this.datePipe.transform(this.SUBTASK_END_DATE, "yyyy-MM-dd");

      this.data5.IS_CHILD = false;
      this.data5.DEPENDENT_TASK_ID = 0;

      this.data5.UPDATED_DATETIME = this.ENQUIRY_DATE
      this.data5.UPDATED_DATETIME = this.datePipe.transform(this.data5.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

      this.data5.TAGS = "";
      this.data5.PROGRESS = 0;
      this.data5.IS_ACTIVE = true;

      this.data5.ASSIGNEES = this.assigneee


      this.data5.REPORTER_ID = this.api.userId;
      this.data5.TYPE = 5;
      this.data5.UPDATED_DATETIME = this.datePipe.transform(this.ENQUIRY_DATE, "yyyy-MM-dd");
      // this.data5.TASK_STATUS='T'


      //   this.api.getTaskSubtaskDetails(this.parenttaskid, 0).subscribe(data => {
      //     if (data['code'] == "200") {
      //       this.mappingData = data['data'];
      //       

      //       for (var i = 0; i < this.mappingData.length; i++) {
      //         for (var j = 0; j < this.TASK_ASSIGNEE_ID.length; j++) {
      //           if (this.mappingData[i]['USER_ID'] == this.TASK_ASSIGNEE_ID[j]) {
      //             this.mappingData[i]['IS_ACTIVE'] = 1;
      //             this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
      //           }
      //         }
      //       }

      //   }else{

      //   }
      // });


      this.api.createSubTask(this.data5).subscribe(successCode => {


        if (successCode['code'] == "200") {


          this.message.success("Sub-Task Added Successfully...", "");
          this.isVisible23 = false;
          this.isConfirmLoading1 = false;
          // this.lotofnames = []
          // this.loadAllProjects()
          this.loadAllProjects1();
          this.SUBTASK = ''
          this.data5 = new taskSubtaskMaster()


          // this.resetDrawer(accountMasterPage);
          this.isSpinning = false;

          this.data7.MASTER_ID = this.parenttaskid
          this.data7.SUBTASK_ID = this.isd
          this.data7.DATE_TIME = this.datePipe.transform(new Date(), "yyyy-MM-dd");

          this.api.daily_sub_task_master(this.data7).subscribe(successCode => {
            // 

            if (successCode['code'] == "200") {

            } else {

            }
          });



        } else {
          this.message.error("Failed To Update Information...", "");
          this.isSpinning = false;
        }
      });
    }
  }

  // For pick
  handlePrintforpick(addNew): void {
    this.isOk = true;

    // this.message.error('Please Enter Item Group Name', '');
    // this.idprint.nativeElement.click();

    if (

      this.data1.PROJECT_ID == 0 &&
      this.data1.SUBTASK_MODULE_ID == 0 &&
      this.data1.SUBTASK_FEATURE_ID == 0 &&
      this.data1.PARENT_TASK_ID == 0
    ) {
      this.isOk = false;
      this.message.error('Please Fill All Required Information', '');

    } else if (this.data1.PROJECT_ID == undefined || this.data1.PROJECT_ID == 0) {
      this.isOk = false
      this.message.error('Please Select Project', '')

    } else if (this.data1.SUBTASK_MODULE_ID == 0 || this.data1.SUBTASK_MODULE_ID == undefined) {
      this.isOk = false;
      this.message.error('Please Select Module', '');

    } else if (this.data1.SUBTASK_FEATURE_ID == 0 || this.data1.SUBTASK_FEATURE_ID == undefined) {
      this.isOk = false;
      this.message.error('Please Select Feature', '');

    } else if (this.data1.PARENT_TASK_ID == 0 || this.data1.PARENT_TASK_ID == undefined) {
      this.isOk = false;
      this.message.error('Please Select Task', '');
    }

    if (this.isOk) {
      this.isConfirmLoading2 = true;
      this.data1.USER_ID = this.api.userId
      this.data1.TASK_ID = this.data1.PARENT_TASK_ID
      this.data1.DATE = this.datePipe.transform(this.ENQUIRY_DATE, "yyyy-MM-dd");
      this.api.Picktask(this.data1).subscribe(successCode => {


        if (successCode['code'] == "200") {


          this.message.success("Task Picked Successfully...", "");
          this.isVisible2 = false;
          this.isConfirmLoading2 = false;
          // this.lotofnames = []
          // this.loadAllProjects()
          this.resetpickmodal();
          this.loadAllProjects1()
          this.data1 = new PickTask();
          // this.loadalltask()

          // this.resetDrawer(accountMasterPage);
          this.isSpinning = false;

        } else {
          this.message.error("Failed To Update Information...", "");
          this.isSpinning = false;
        }
      });
    }
  }
  worklogData = []
  resetpickmodal() {
    this.data1.PROJECT_ID == null
    this.data1.SUBTASK_MODULE_ID == null
    this.data1.SUBTASK_FEATURE_ID == null
    this.data1.PARENT_TASK_ID == null
  }

  handlePrint1(addNew): void {
    var isOk = true;

    if (this.data6.WORKED_DATETIME != undefined) {
      if (this.data6.WORKED_DATETIME == null) {
        isOk = false;
        this.notificationService.error("Please Select Start Date Time", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select Start Date Time", "");
    }

    if (this.data6.END_DATETIME != undefined) {
      if (this.data6.END_DATETIME == null) {
        isOk = false;
        this.notificationService.error("Please Select End Date Time", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select End Date Time", "");
    }


    if (this.data6.SPENT_HOURS == 0 && this.data6.SPENT_MINUTES == 0 && this.data6.SPENT_SECONDS == 0) {
      isOk = false;
      this.notificationService.error("Please Enter Valid Spent Time", "");
    }

    if (this.data6.WORK_DESCRIPTION == undefined && this.data6.WORK_DESCRIPTION == '') {

      isOk = false;
      this.notificationService.error("Please Enter Valid Work Description", "");


    }

    if (isOk) {
      this.isConfirmLoading = true;
      this.isSpinning = true;
      this.data6.USER_ID = this.api.userId;
      this.data6.TYPE = 5
      this.data6.TYPE_ID = this.taskid;
      this.data6.IS_ACTIVE = true;

      this.data6.WORKED_DATETIME = this.datePipe.transform(this.data6.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data6.START_DATETIME = this.datePipe.transform(this.data6.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data6.END_DATETIME = this.datePipe.transform(this.data6.END_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data6.PROJECT_ID = this.pro



      if (!this.data6.ID) {
        this.api.createWorklog1(this.data6).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.isVisible234 = false;
            this.isConfirmLoading = false;
            this.notificationService.success("Worklog Added Successfully", "");
            // this.getWorklogIDWise(typeID)
            this.loadAllProjects1()
            this.isSpinning = false;
            this.data6 = new worklogM();
          } else {
            this.notificationService.error("Failed to Add Worklog", "");

          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this.api.updateWorklog(this.data6).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Worklog Updated Successfully", "");
            this.isVisible234 = false;
            this.isConfirmLoading = false;
            this.loadAllProjects1()
            this.isSpinning = false;


            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Worklog", "");

          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  reset() {
    // this.message.error("message.message.message.", "");
    this.data.PROJECT_ID == null
    this.data.DATE == ''
  }
  accessPageForRedirect() {
    if (this.roleId != 0) {
      let url = window.location.href;
      var arr = url.split("/");

      let validPage = "/" + arr[3];
      this.api.getCheckAccessOfForm(this.roleId, validPage).subscribe(data => {
        if (data['data'] == true) {
          this.router.navigateByUrl(validPage);
          this.pageName = arr[3];

        } else {
          if (validPage != "/login") {
            this.api.logoutForSessionValues()
          }
        }
      });
    }
  }

  loadForms() {
    this.api.getForms(this.roleId).subscribe(data => {
      if (data['code'] == 200) {
        data['data'].forEach(element => {
          element['children'].sort(this.sortFunction)

          if (element['children'].length == 0)
            delete element['children']
        });

        this.menus = data['data'].sort(this.sortFunction)
      }
    });
  }

  sortFunction(a, b) {
    var dateA = a.SEQ_NO
    var dateB = b.SEQ_NO
    return dateA > dateB ? 1 : -1;
  };

  // isSpinning = false;

  logout() {
    this.isSpinning = true;

    setTimeout(() => {
      this.api.logoutForSessionValues();
      this.isSpinning = false;
    }, 1000);
  }

  modalName = "Create Issue";
  PROJECT_ID = 0;
  ISSUE_TYPE = "";

  MODULE_NAME = "";
  MODULE_DESCRIPTION = "";
  MODULE_ASSIGNEE_ID = [];
  MODULE_START_DATE: Date = null;
  MODULE_END_DATE: Date = null;
  MODULE_ESTIMATED_MANDAYS = 0;

  MODULE_ID = 0;
  FEATURE_NAME = "";
  FEATURE_DESCRIPTION = "";
  FEATURE_ASSIGNEE_ID = [];
  FEATURE_START_DATE: Date = null;
  FEATURE_END_DATE: Date = null;
  FEATURE_ESTIMATED_MANDAYS = 0;

  TASK_MODULE_ID = 0;
  TASK_FEATURE_ID = 0;
  TASK_NAME = "";
  TASK_DESCRIPTION = "";
  TASK_ASSIGNEE_ID = [];
  TASK_START_DATE: Date = null;
  TASK_END_DATE: Date = null;
  TASK_CATEGORY_ID = 0;
  TASK_PRIORITY = "L";
  TASK_ESTIMATED_HOURS = 0;
  TASK_ESTIMATED_MINUTES = 0;
  TASK_ESTIMATED_SECONDS = 0;

  SUBTASK_MODULE_ID = 0;
  SUBTASK_FEATURE_ID = 0;
  PARENT_TASK_ID = 0;
  SUBTASK_NAME = "";
  SUBTASK_DESCRIPTION = "";
  SUBTASK_ASSIGNEE_ID = [];
  SUBTASK_START_DATE: Date = null;
  SUBTASK_END_DATE: Date = null;
  SUBTASK_CATEGORY_ID = 0;
  SUBTASK_PRIORITY = "L";
  SUBTASK_ESTIMATED_HOURS = 0;
  SUBTASK_ESTIMATED_MINUTES = 0;
  SUBTASK_ESTIMATED_SECONDS = 0;

  isVisible = false;

  moduleDrawerVisible: boolean = false;
  moduleDrawerData = new moduleMaster;

  featureDrawerVisible: boolean = false;
  featureDrawerData = new featureMaster;

  taskDrawerVisible: boolean = false;
  taskDrawerData = new taskSubtaskMaster;

  subtaskDrawerVisible: boolean = false;
  subtaskDrawerData = new taskSubtaskMaster;

  isListLoading = false;

  moduleButtonHidden = true;
  featureButtonHidden = true;
  taskButtonHidden = true;
  subtaskButtonHidden = true;

  showModal(): void {
    this.loadAllProjects();

    // this.data1.PROJECT_ID = 0;
    // var defaultProject = sessionStorage.getItem("projectID");
    // this.data1.PROJECT_ID = parseInt(defaultProject);

    this.hideShowRadioButtons();
  }

  levelVar = "0";

  hideShowRadioButtons() {
    this.moduleButtonHidden = true;
    this.featureButtonHidden = true;
    this.taskButtonHidden = true;
    this.subtaskButtonHidden = true;

    this.isVisible = true;

    this.moduleDrawerVisible = false;
    this.featureDrawerVisible = false;
    this.taskDrawerVisible = false;
    this.subtaskDrawerVisible = false;

    this.ISSUE_TYPE = "";

    if (this.levelVar == "1" || this.levelVar == "2" || this.levelVar == "3") {
      this.moduleButtonHidden = false;
      this.featureButtonHidden = false;
      this.taskButtonHidden = false;
      this.subtaskButtonHidden = false;

      // } else if(this.cookie.get("level")== "3") {
      // if(this.cookie.get("roleName")== "Project Manager") {
      //   this.moduleButtonHidden= false;
      //   this.featureButtonHidden= false;
      //   this.taskButtonHidden= true;
      //   this.subtaskButtonHidden= true;

      // } else if(this.cookie.get("roleName")== "Bussiness Analyst" || this.cookie.get("roleName")== "Owner") {
      //   this.moduleButtonHidden= false;
      //   this.featureButtonHidden= true;
      //   this.taskButtonHidden= true;
      //   this.subtaskButtonHidden= true;
      // }

    } else if (this.levelVar == "4") {
      this.moduleButtonHidden = true;
      this.featureButtonHidden = true;
      this.taskButtonHidden = false;
      this.subtaskButtonHidden = false;

    } else if (this.levelVar == "5") {
      this.moduleButtonHidden = true;
      this.featureButtonHidden = true;
      this.taskButtonHidden = true;
      this.subtaskButtonHidden = false;
    }
  }

  isFeatureModuleLoading = false;

  isTaskModuleLoading = false;
  isTaskFeatureLoading = false;
  isTaskCategoryLoading = false;

  isSubtaskModuleLoading = false;
  isSubtaskFeatureLoading = false;
  isSubtaskParentTaskLoading = false;
  isSubtaskCategoryLoading = false;

  radioButtonChange() {
    this.getRoleProjectWise(this.data1.PROJECT_ID);
    this.loadAllRoles();
    this.loadAllAssignee();
    this.loadAllCategories();
    this.loadAllModules();
  }

  mappingData: any = [];

  // handleOk(clear: true): void {
  //   if (this.ISSUE_TYPE == "M") {
  //     var isOK = true;

  //     if (this.data1.PROJECT_ID != undefined) {
  //       if (this.data1.PROJECT_ID.toString() == "" || this.data1.PROJECT_ID.toString() == "NaN" || this.data1.PROJECT_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Project", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Project", "");
  //     }

  //     if (this.MODULE_NAME != undefined) {
  //       if (this.MODULE_NAME.trim() == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Module Name", "");
  //       }
  //     }

  //     // if(this.MODULE_DESCRIPTION!= undefined) {
  //     //   if(this.MODULE_DESCRIPTION.trim()== "") {
  //     //     isOK= false;
  //     //     this.notificationService.error("Please Enter Valid Module Description","");
  //     //   }
  //     // }

  //     if (this.MODULE_ASSIGNEE_ID != undefined) {
  //       if (this.MODULE_ASSIGNEE_ID.length == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Assignee", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Assignee", "");
  //     }

  //     // if (this.MODULE_START_DATE != undefined) {
  //     //   if (this.MODULE_START_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid Start Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid Start Date", "");
  //     // }

  //     // if (this.MODULE_END_DATE != undefined) {
  //     //   if (this.MODULE_END_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid End Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid End Date", "");
  //     // }

  //     if (this.MODULE_ESTIMATED_MANDAYS != undefined) {
  //       if (this.MODULE_ESTIMATED_MANDAYS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Mandays", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Mandays", "");
  //     }

  //     if (isOK) {
  //       this.moduleDrawerData.PROJECT_ID = this.data1.PROJECT_ID;
  //       this.moduleDrawerData.NAME = this.MODULE_NAME;
  //       this.moduleDrawerData.DESCRIPTION = this.MODULE_DESCRIPTION;
  //       this.moduleDrawerData.ESTIMATED_MANDAYS = this.MODULE_ESTIMATED_MANDAYS;
  //       this.moduleDrawerData.ESTIMATED_HOURS = 0;
  //       this.moduleDrawerData.ESTIMATED_MINUTES = 0;
  //       this.moduleDrawerData.ESTIMATED_SECONDS = 0;
  //       this.moduleDrawerData.START_DATE = this.datePipe.transform(this.MODULE_START_DATE, "yyyy-MM-dd");
  //       this.moduleDrawerData.END_DATE = this.datePipe.transform(this.MODULE_END_DATE, "yyyy-MM-dd");
  //       this.moduleDrawerData.STATUS = "P";
  //       this.moduleDrawerData.IS_ACTIVE = true;

  //       this.moduleDrawerData.ASSIGNEES = this.MODULE_ASSIGNEE_ID;
  //       this.moduleDrawerData.REPORTER_ID = this.api.userId;
  //       this.moduleDrawerData.TYPE = 2;

  //       

  //       this.api.createModule(this.moduleDrawerData).subscribe(successCode => {
  //         if (successCode['code'] == "200") {
  //           this.notificationService.success("Module Successfully Created", "");
  //           // this.handleCancel();
  //           // this.modalClear();

  //           // Get Module Mapping Details
  //           
  //           var createdModuleID = successCode['insertId'];

  //           this.api.getModuleDetails(createdModuleID, 0).subscribe(data => {
  //             if (data['code'] == "200") {
  //               this.mappingData = data['data'];
  //               

  //               for (var i = 0; i < this.mappingData.length; i++) {
  //                 for (var j = 0; j < this.MODULE_ASSIGNEE_ID.length; j++) {
  //                   if (this.mappingData[i]['USER_ID'] == this.MODULE_ASSIGNEE_ID[j]) {
  //                     this.mappingData[i]['IS_ACTIVE'] = 1;
  //                     this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
  //                   }
  //                 }
  //               }

  //               

  //               this.api.addModuleMappingDetails(createdModuleID, this.mappingData).subscribe(successCode => {
  //                 if (successCode['code'] == "200") {
  //                   this.notificationService.success("Module Successfully Mapped", "");

  //                   if (clear) {
  //                     this.modalClear();
  //                     this.handleCancel();

  //                   } else {
  //                     this.clearOnlyTextFields();
  //                   }
  //                 }

  //                 else {
  //                   this.notificationService.error("Module Mapping Failed", "");
  //                 }
  //               });
  //             }

  //           }, err => {
  //             
  //           });

  //         } else {
  //           this.notificationService.error("Failed to Create Module", "");
  //         }

  //       }, err => {
  //         if (err["ok"] == false) {
  //           this.notificationService.error("Server Not Found", "");
  //         }
  //       });
  //     }

  //   } else if (this.ISSUE_TYPE == "F") {
  //     var isOK = true;

  //     if (this.data1.PROJECT_ID != undefined) {
  //       if (this.data1.PROJECT_ID.toString() == "" || this.data1.PROJECT_ID.toString() == "NaN" || this.data1.PROJECT_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Project", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Project", "");
  //     }

  //     if (this.MODULE_ID != undefined) {
  //       if (this.MODULE_ID == null || this.MODULE_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Module", "");
  //       }
  //     }

  //     if (this.FEATURE_NAME != undefined) {
  //       if (this.FEATURE_NAME.trim() == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Feature Name", "");
  //       }
  //     }

  //     // if(this.FEATURE_DESCRIPTION!= undefined) {
  //     //   if(this.FEATURE_DESCRIPTION.trim()== "") {
  //     //     isOK= false;
  //     //     this.notificationService.error("Please Enter Valid Feature Description","");
  //     //   }
  //     // }

  //     if (this.FEATURE_ASSIGNEE_ID != undefined) {
  //       if (this.FEATURE_ASSIGNEE_ID.length == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Assignee", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Assignee", "");
  //     }

  //     // if (this.FEATURE_START_DATE != undefined) {
  //     //   if (this.FEATURE_START_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid Start Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid Start Date", "");
  //     // }

  //     // if (this.FEATURE_END_DATE != undefined) {
  //     //   if (this.FEATURE_END_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid End Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid End Date", "");
  //     // }

  //     if (this.FEATURE_ESTIMATED_MANDAYS != undefined) {
  //       if (this.FEATURE_ESTIMATED_MANDAYS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Mandays", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Mandays", "");
  //     }

  //     if (isOK) {
  //       this.featureDrawerData.MODULE_ID = this.MODULE_ID;
  //       this.featureDrawerData.NAME = this.FEATURE_NAME;
  //       this.featureDrawerData.DESCRIPTION = this.FEATURE_DESCRIPTION;
  //       this.featureDrawerData.ESTIMATED_MANDAYS = this.FEATURE_ESTIMATED_MANDAYS;
  //       this.featureDrawerData.ESTIMATED_HOURS = 0;
  //       this.featureDrawerData.ESTIMATED_MINUTES = 0;
  //       this.featureDrawerData.ESTIMATED_SECONDS = 0;
  //       this.featureDrawerData.START_DATE = this.datePipe.transform(this.FEATURE_START_DATE, "yyyy-MM-dd");
  //       this.featureDrawerData.END_DATE = this.datePipe.transform(this.FEATURE_END_DATE, "yyyy-MM-dd");
  //       this.featureDrawerData.STATUS = "P";
  //       this.featureDrawerData.IS_ACTIVE = true;

  //       this.featureDrawerData.ASSIGNEES = this.FEATURE_ASSIGNEE_ID;
  //       this.featureDrawerData.REPORTER_ID = this.api.userId;
  //       this.featureDrawerData.TYPE = 3;

  //       

  //       this.api.createFeature(this.featureDrawerData).subscribe(successCode => {
  //         if (successCode['code'] == "200") {
  //           this.notificationService.success("Feature Successfully Created", "");
  //           // this.handleCancel();
  //           // this.modalClear();

  //           // Get Feature Mapping Details
  //           
  //           var createdFeatureID = successCode['insertId'];

  //           this.api.getFeatureDetails(createdFeatureID, 0).subscribe(data => {
  //             if (data['code'] == "200") {
  //               this.mappingData = data['data'];
  //               

  //               for (var i = 0; i < this.mappingData.length; i++) {
  //                 for (var j = 0; j < this.FEATURE_ASSIGNEE_ID.length; j++) {
  //                   if (this.mappingData[i]['USER_ID'] == this.FEATURE_ASSIGNEE_ID[j]) {
  //                     this.mappingData[i]['IS_ACTIVE'] = 1;
  //                     this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
  //                   }
  //                 }
  //               }

  //               

  //               this.api.addFeatureMappingDetails(createdFeatureID, this.mappingData).subscribe(successCode => {
  //                 if (successCode['code'] == "200") {
  //                   this.notificationService.success("Feature Successfully Mapped", "");

  //                   if (clear) {
  //                     this.modalClear();
  //                     this.handleCancel();

  //                   } else {
  //                     this.clearOnlyTextFields();
  //                   }
  //                 }

  //                 else {
  //                   this.notificationService.error("Feature Mapping Failed", "");
  //                 }
  //               });
  //             }

  //           }, err => {
  //             
  //           });

  //         } else {
  //           this.notificationService.error("Failed to Create Feature", "");
  //         }

  //       }, err => {
  //         if (err["ok"] == false) {
  //           this.notificationService.error("Server Not Found", "");
  //         }
  //       });
  //     }

  //   } else if (this.ISSUE_TYPE == "T") {
  //     var isOK = true;

  //     if (this.data1.PROJECT_ID != undefined) {
  //       if (this.data1.PROJECT_ID.toString() == "" || this.data1.PROJECT_ID.toString() == "NaN" || this.data1.PROJECT_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Project", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Project", "");
  //     }

  //     if (this.TASK_MODULE_ID != undefined) {
  //       if (this.TASK_MODULE_ID == null || this.TASK_MODULE_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Module", "");
  //       }
  //     }

  //     if (this.TASK_FEATURE_ID != undefined) {
  //       if (this.TASK_FEATURE_ID == null || this.TASK_FEATURE_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Feature", "");
  //       }
  //     }

  //     if (this.TASK_NAME != undefined) {
  //       if (this.TASK_NAME.trim() == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Task Name", "");
  //       }
  //     }

  //     // if(this.TASK_DESCRIPTION!= undefined) {
  //     //   if(this.TASK_DESCRIPTION.trim()== "") {
  //     //     isOK= false;
  //     //     this.notificationService.error("Please Enter Valid Task Description","");
  //     //   }
  //     // }

  //     if (this.TASK_ASSIGNEE_ID != undefined) {
  //       if (this.TASK_ASSIGNEE_ID.length == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Assignee", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Assignee", "");
  //     }

  //     if (this.TASK_CATEGORY_ID != undefined) {
  //       if (this.TASK_CATEGORY_ID == null || this.TASK_CATEGORY_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Task Category", "");
  //       }
  //     }

  //     if (this.TASK_PRIORITY != undefined) {
  //       if (this.TASK_PRIORITY == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Task Priority", "");
  //       }
  //     }

  //     // if (this.TASK_START_DATE != undefined) {
  //     //   if (this.TASK_START_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid Start Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid Start Date", "");
  //     // }

  //     // if (this.TASK_END_DATE != undefined) {
  //     //   if (this.TASK_END_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid End Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid End Date", "");
  //     // }

  //     if (this.TASK_ESTIMATED_HOURS != undefined) {
  //       if (this.TASK_ESTIMATED_HOURS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Hours", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Hours", "");
  //     }

  //     if (this.TASK_ESTIMATED_MINUTES != undefined) {
  //       if (this.TASK_ESTIMATED_MINUTES == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Minutes", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Minutes", "");
  //     }

  //     if (this.TASK_ESTIMATED_SECONDS != undefined) {
  //       if (this.TASK_ESTIMATED_SECONDS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Seconds", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Seconds", "");
  //     }

  //     if (isOK) {
  //       this.taskDrawerData.TASK_CATEGORY_ID = this.TASK_CATEGORY_ID;
  //       this.taskDrawerData.FEATURE_ID = this.TASK_FEATURE_ID;
  //       this.taskDrawerData.PARENT_ID = 0;
  //       this.taskDrawerData.NAME = this.TASK_NAME;
  //       this.taskDrawerData.DESCRIPTION = this.TASK_DESCRIPTION;
  //       this.taskDrawerData.ESTIMATED_HOURS = this.TASK_ESTIMATED_HOURS;
  //       this.taskDrawerData.ESTIMATED_MINUTES = this.TASK_ESTIMATED_MINUTES;
  //       this.taskDrawerData.ESTIMATED_SECONDS = this.TASK_ESTIMATED_SECONDS;

  //       this.taskDrawerData.PRIORITY = this.TASK_PRIORITY;

  //       this.taskDrawerData.TIME_TRACKED = new Date();
  //       this.taskDrawerData.TIME_TRACKED = this.datePipe.transform(this.taskDrawerData.TIME_TRACKED, "HH:mm") + ":00";

  //       this.taskDrawerData.STATUS = "P";

  //       this.taskDrawerData.START_DATE = this.datePipe.transform(this.TASK_START_DATE, "yyyy-MM-dd");
  //       this.taskDrawerData.END_DATE = this.datePipe.transform(this.TASK_END_DATE, "yyyy-MM-dd");

  //       this.taskDrawerData.IS_CHILD = false;
  //       this.taskDrawerData.DEPENDENT_TASK_ID = 0;

  //       this.taskDrawerData.UPDATED_DATETIME = new Date();
  //       this.taskDrawerData.UPDATED_DATETIME = this.datePipe.transform(this.taskDrawerData.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

  //       this.taskDrawerData.TAGS = "";
  //       this.taskDrawerData.PROGRESS = 0;
  //       this.taskDrawerData.IS_ACTIVE = true;

  //       this.taskDrawerData.ASSIGNEES = this.TASK_ASSIGNEE_ID;
  //       this.taskDrawerData.REPORTER_ID = this.api.userId;
  //       this.taskDrawerData.TYPE = 4;

  //       

  //       this.api.createTaskSubtask(this.taskDrawerData).subscribe(successCode => {
  //         if (successCode['code'] == "200") {
  //           this.notificationService.success("Task Successfully Created", "");
  //           // this.handleCancel();
  //           // this.modalClear();

  //           // Get Task Mapping Details
  //           
  //           var createdTaskID = successCode['insertId'];

  //           this.api.getTaskSubtaskDetails(createdTaskID, 0).subscribe(data => {
  //             if (data['code'] == "200") {
  //               this.mappingData = data['data'];
  //               

  //               for (var i = 0; i < this.mappingData.length; i++) {
  //                 for (var j = 0; j < this.TASK_ASSIGNEE_ID.length; j++) {
  //                   if (this.mappingData[i]['USER_ID'] == this.TASK_ASSIGNEE_ID[j]) {
  //                     this.mappingData[i]['IS_ACTIVE'] = 1;
  //                     this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
  //                   }
  //                 }
  //               }

  //               

  //               this.api.addTaskSubtaskMappingDetails(createdTaskID, this.mappingData).subscribe(successCode => {
  //                 if (successCode['code'] == "200") {
  //                   this.notificationService.success("Task Successfully Mapped", "");

  //                   if (clear) {
  //                     this.modalClear();
  //                     this.handleCancel();

  //                   } else {
  //                     this.clearOnlyTextFields();
  //                   }
  //                 }

  //                 else {
  //                   this.notificationService.error("Task Mapping Failed", "");
  //                 }
  //               });
  //             }

  //           }, err => {
  //             
  //           });

  //         } else {
  //           this.notificationService.error("Failed to Create Task", "");
  //         }

  //       }, err => {
  //         if (err["ok"] == false) {
  //           this.notificationService.error("Server Not Found", "");
  //         }
  //       });
  //     }

  //   } else if (this.ISSUE_TYPE == "S") {
  //     var isOK = true;

  //     if (this.data1.PROJECT_ID != undefined) {
  //       if (this.data1.PROJECT_ID.toString() == "" || this.data1.PROJECT_ID.toString() == "NaN" || this.data1.PROJECT_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Project", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Project", "");
  //     }

  //     if (this.SUBTASK_MODULE_ID != undefined) {
  //       if (this.SUBTASK_MODULE_ID == null || this.SUBTASK_MODULE_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Module", "");
  //       }
  //     }

  //     if (this.SUBTASK_FEATURE_ID != undefined) {
  //       if (this.SUBTASK_FEATURE_ID == null || this.SUBTASK_FEATURE_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Feature", "");
  //       }
  //     }

  //     if (this.PARENT_TASK_ID != undefined) {
  //       if (this.PARENT_TASK_ID == null || this.PARENT_TASK_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Parent Task", "");
  //       }
  //     }

  //     if (this.SUBTASK_NAME != undefined) {
  //       if (this.SUBTASK_NAME.trim() == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Subtask Name", "");
  //       }
  //     }

  //     // if(this.SUBTASK_DESCRIPTION!= undefined) {
  //     //   if(this.SUBTASK_DESCRIPTION.trim()== "") {
  //     //     isOK= false;
  //     //     this.notificationService.error("Please Enter Valid Subtask Description","");
  //     //   }
  //     // }

  //     if (this.SUBTASK_ASSIGNEE_ID != undefined) {
  //       if (this.SUBTASK_ASSIGNEE_ID.length == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Assignee", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Select Valid Assignee", "");
  //     }

  //     if (this.SUBTASK_CATEGORY_ID != undefined) {
  //       if (this.SUBTASK_CATEGORY_ID == null || this.SUBTASK_CATEGORY_ID == 0) {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Subtask Category", "");
  //       }
  //     }

  //     if (this.SUBTASK_PRIORITY != undefined) {
  //       if (this.SUBTASK_PRIORITY == "") {
  //         isOK = false;
  //         this.notificationService.error("Please Select Valid Subtask Priority", "");
  //       }
  //     }

  //     // if (this.SUBTASK_START_DATE != undefined) {
  //     //   if (this.SUBTASK_START_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid Start Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid Start Date", "");
  //     // }

  //     // if (this.SUBTASK_END_DATE != undefined) {
  //     //   if (this.SUBTASK_END_DATE == null) {
  //     //     isOK = false;
  //     //     this.notificationService.error("Please Select Valid End Date", "");
  //     //   }
  //     // } else {
  //     //   isOK = false;
  //     //   this.notificationService.error("Please Select Valid End Date", "");
  //     // }

  //     if (this.SUBTASK_ESTIMATED_HOURS != undefined) {
  //       if (this.SUBTASK_ESTIMATED_HOURS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Hours", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Hours", "");
  //     }

  //     if (this.SUBTASK_ESTIMATED_MINUTES != undefined) {
  //       if (this.SUBTASK_ESTIMATED_MINUTES == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Minutes", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Minutes", "");
  //     }

  //     if (this.SUBTASK_ESTIMATED_SECONDS != undefined) {
  //       if (this.SUBTASK_ESTIMATED_SECONDS == null) {
  //         isOK = false;
  //         this.notificationService.error("Please Enter Valid Estimate Seconds", "");
  //       }
  //     } else {
  //       isOK = false;
  //       this.notificationService.error("Please Enter Valid Estimate Seconds", "");
  //     }

  //     if (isOK) {
  //       this.taskDrawerData.TASK_CATEGORY_ID = this.SUBTASK_CATEGORY_ID;
  //       this.taskDrawerData.FEATURE_ID = this.SUBTASK_FEATURE_ID;
  //       this.taskDrawerData.PARENT_ID = this.PARENT_TASK_ID;
  //       this.taskDrawerData.NAME = this.SUBTASK_NAME;
  //       this.taskDrawerData.DESCRIPTION = this.SUBTASK_DESCRIPTION;
  //       this.taskDrawerData.ESTIMATED_HOURS = this.SUBTASK_ESTIMATED_HOURS;
  //       this.taskDrawerData.ESTIMATED_MINUTES = this.SUBTASK_ESTIMATED_MINUTES;
  //       this.taskDrawerData.ESTIMATED_SECONDS = this.SUBTASK_ESTIMATED_SECONDS;

  //       this.taskDrawerData.PRIORITY = this.SUBTASK_PRIORITY;

  //       this.taskDrawerData.TIME_TRACKED = new Date();
  //       this.taskDrawerData.TIME_TRACKED = this.datePipe.transform(this.taskDrawerData.TIME_TRACKED, "HH:mm") + ":00";

  //       this.taskDrawerData.STATUS = "P";

  //       this.taskDrawerData.START_DATE = this.datePipe.transform(this.SUBTASK_START_DATE, "yyyy-MM-dd");
  //       this.taskDrawerData.END_DATE = this.datePipe.transform(this.SUBTASK_END_DATE, "yyyy-MM-dd");

  //       this.taskDrawerData.IS_CHILD = false;
  //       this.taskDrawerData.DEPENDENT_TASK_ID = 0;

  //       this.taskDrawerData.UPDATED_DATETIME = new Date();
  //       this.taskDrawerData.UPDATED_DATETIME = this.datePipe.transform(this.taskDrawerData.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";

  //       this.taskDrawerData.TAGS = "";
  //       this.taskDrawerData.PROGRESS = 0;
  //       this.taskDrawerData.IS_ACTIVE = true;

  //       this.taskDrawerData.ASSIGNEES = this.SUBTASK_ASSIGNEE_ID;
  //       this.taskDrawerData.REPORTER_ID = this.api.userId;
  //       this.taskDrawerData.TYPE = 5;

  //       

  //       this.api.createTaskSubtask(this.taskDrawerData).subscribe(successCode => {
  //         if (successCode['code'] == "200") {
  //           this.notificationService.success("Subtask Successfully Created", "");
  //           // this.handleCancel();
  //           // this.modalClear();

  //           // Get Subtask Mapping Details
  //           
  //           var createdTaskID = successCode['insertId'];

  //           this.api.getTaskSubtaskDetails(createdTaskID, 0).subscribe(data => {
  //             if (data['code'] == "200") {
  //               this.mappingData = data['data'];
  //               

  //               for (var i = 0; i < this.mappingData.length; i++) {
  //                 for (var j = 0; j < this.SUBTASK_ASSIGNEE_ID.length; j++) {
  //                   if (this.mappingData[i]['USER_ID'] == this.SUBTASK_ASSIGNEE_ID[j]) {
  //                     this.mappingData[i]['IS_ACTIVE'] = 1;
  //                     this.mappingData[i]['ROLE_ID'] = Number(this.mappingData[i]['ROLE_IDS']);
  //                   }
  //                 }
  //               }

  //               

  //               this.api.addTaskSubtaskMappingDetails(createdTaskID, this.mappingData).subscribe(successCode => {
  //                 if (successCode['code'] == "200") {
  //                   this.notificationService.success("Subtask Successfully Mapped", "");

  //                   if (clear) {
  //                     this.modalClear();
  //                     this.handleCancel();

  //                   } else {
  //                     this.clearOnlyTextFields();
  //                   }
  //                 }

  //                 else {
  //                   this.notificationService.error("Subtask Mapping Failed", "");
  //                 }
  //               });
  //             }

  //           }, err => {
  //             
  //           });

  //         } else {
  //           this.notificationService.error("Failed to Create Subtask", "");
  //         }

  //       }, err => {
  //         if (err["ok"] == false) {
  //           this.notificationService.error("Server Not Found", "");
  //         }
  //       });
  //     }
  //   }
  // }

  moduleDrawerClose() {
    this.moduleDrawerVisible = false;
  }

  callBackModuleDrawerClose() {
    this.moduleDrawerClose.bind(this);
  }

  featureDrawerClose() {
    this.featureDrawerVisible = false;
  }

  callBackFeatureDrawerClose() {
    this.featureDrawerClose.bind(this);
  }

  // handleCancel(): void {
  //   this.isVisible = false;
  //   this.modalClear();

  //   window.location.reload();
  // }

  modalClear() {
    this.ISSUE_TYPE = "";
    this.moduleDrawerVisible = false;
    this.featureDrawerVisible = false;
    this.taskDrawerVisible = false;
    this.subtaskDrawerVisible = false;

    this.MODULE_NAME = "";
    this.MODULE_DESCRIPTION = "";
    this.MODULE_ASSIGNEE_ID = [];
    this.MODULE_START_DATE = null;
    this.MODULE_END_DATE = null;
    this.MODULE_ESTIMATED_MANDAYS = 0;

    this.MODULE_ID = 0;
    this.FEATURE_NAME = "";
    this.FEATURE_DESCRIPTION = "";
    this.FEATURE_ASSIGNEE_ID = [];
    this.FEATURE_START_DATE = null;
    this.FEATURE_END_DATE = null;
    this.FEATURE_ESTIMATED_MANDAYS = 0;

    this.TASK_MODULE_ID = 0;
    this.TASK_FEATURE_ID = 0;
    this.TASK_NAME = "";
    this.TASK_DESCRIPTION = "";
    this.TASK_ASSIGNEE_ID = [];
    this.TASK_START_DATE = null;
    this.TASK_END_DATE = null;
    this.TASK_CATEGORY_ID = 0;
    this.TASK_PRIORITY = "L";
    this.TASK_ESTIMATED_HOURS = 0;
    this.TASK_ESTIMATED_MINUTES = 0;
    this.TASK_ESTIMATED_SECONDS = 0;

    this.SUBTASK_MODULE_ID = 0;
    this.SUBTASK_FEATURE_ID = 0;
    this.PARENT_TASK_ID = 0;
    this.SUBTASK_NAME = "";
    this.SUBTASK_DESCRIPTION = "";
    this.SUBTASK_ASSIGNEE_ID = [];
    this.SUBTASK_START_DATE = null;
    this.SUBTASK_END_DATE = null;
    this.SUBTASK_CATEGORY_ID = 0;
    this.SUBTASK_PRIORITY = "L";
    this.SUBTASK_ESTIMATED_HOURS = 0;
    this.SUBTASK_ESTIMATED_MINUTES = 0;
    this.SUBTASK_ESTIMATED_SECONDS = 0;
  }

  clearOnlyTextFields() {


    // this.ISSUE_TYPE = "";
    // this.moduleDrawerVisible = false;
    // this.featureDrawerVisible = false;
    // this.taskDrawerVisible = false;
    // this.subtaskDrawerVisible = false;

    this.MODULE_NAME = "";
    this.MODULE_DESCRIPTION = "";
    // this.MODULE_ASSIGNEE_ID = [];
    this.MODULE_START_DATE = null;
    this.MODULE_END_DATE = null;
    this.MODULE_ESTIMATED_MANDAYS = 0;

    // this.MODULE_ID = 0;
    this.FEATURE_NAME = "";
    this.FEATURE_DESCRIPTION = "";
    // this.FEATURE_ASSIGNEE_ID = [];
    this.FEATURE_START_DATE = null;
    this.FEATURE_END_DATE = null;
    this.FEATURE_ESTIMATED_MANDAYS = 0;

    // this.TASK_MODULE_ID = 0;
    // this.TASK_FEATURE_ID = 0;
    this.TASK_NAME = "";
    this.TASK_DESCRIPTION = "";
    // this.TASK_ASSIGNEE_ID = [];
    this.TASK_START_DATE = null;
    this.TASK_END_DATE = null;
    // this.TASK_CATEGORY_ID = 0;
    this.TASK_PRIORITY = "L";
    this.TASK_ESTIMATED_HOURS = 0;
    this.TASK_ESTIMATED_MINUTES = 0;
    this.TASK_ESTIMATED_SECONDS = 0;

    // this.SUBTASK_MODULE_ID = 0;
    // this.SUBTASK_FEATURE_ID = 0;
    // this.PARENT_TASK_ID = 0;
    this.SUBTASK_NAME = "";
    this.SUBTASK_DESCRIPTION = "";
    // this.SUBTASK_ASSIGNEE_ID = [];
    this.SUBTASK_START_DATE = null;
    this.SUBTASK_END_DATE = null;
    // this.SUBTASK_CATEGORY_ID = 0;
    this.SUBTASK_PRIORITY = "L";
    this.SUBTASK_ESTIMATED_HOURS = 0;
    this.SUBTASK_ESTIMATED_MINUTES = 0;
    this.SUBTASK_ESTIMATED_SECONDS = 0;
  }

  // projectList = [];

  loadAllProjects() {
    this.projectList = [];
    this.isListLoading = true;


    // if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
    //   this.api.getAllProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1').subscribe(projectData => {
    //     if (projectData['code'] == 200) {
    //       this.isListLoading = false;
    //       
    //       this.projectList = projectData['data'];
    //     }

    //   }, err => {
    //     
    //   });

    // } else {
    this.api.getAllMappedProjects(0, 0, 'START_DATE', 'desc', ' and IS_ACTIVE=1 and USER_ID=' + this.api.userId).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.isListLoading = false;

        this.projectList = projectData['data'];
      }

    }, err => {

    });
    // }
  }

  assigneeList = [];

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this.api.userId;

    // this.api.getAllUsers(0, 0, 'ID', 'desc', ' and ID!=' + USER_ID).subscribe(userData => {
    //   
    //   
    //   this.assigneeList = userData['data'];

    // }, err => {
    //   
    // });

    this.api.getAllMappedUsers(0, 0, 'LEVEL', 'asc', ' and IS_ACTIVE=1 and PROJECT_ID=' + this.data1.PROJECT_ID).subscribe(userData => {
      if (userData['code'] == 200) {


        this.assigneeList = userData['data'];

        this.findNewAssigneeList();
      }

    }, err => {

    });
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this.api.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();
        }

      }, err => {

      });

    } else {
      // this.api.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL in (' + level + ')').subscribe(data => {
      this.api.getAllRoles(0, 0, 'ID', 'asc', '').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();
        }

      }, err => {

      });
    }
  }

  newAssigneeList = [];

  findNewAssigneeList() {
    this.newAssigneeList = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (this.assigneeList[k]['ROLE_ID'] == this.roleData[j]['ID']) {
          this.newAssigneeList.push(this.assigneeList[k]);
        }
      }
    }




    // Pre select of Level 3 Users
    this.MODULE_ASSIGNEE_ID = [];
    this.FEATURE_ASSIGNEE_ID = [];
    this.TASK_ASSIGNEE_ID = [];
    this.SUBTASK_ASSIGNEE_ID = [];

    var currentCat = 0;

    for (var i = 0; i < this.newAssigneeList.length; i++) {
      // if (this.newAssigneeList[i]['LEVEL'] == 4) {
      //   this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      //   this.TASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      //   this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      // }

      // if (this.newAssigneeList[i]['LEVEL'] == 3 || this.newAssigneeList[i]['LEVEL'] == 4) {
      //   this.FEATURE_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      // }

      if (this.newAssigneeList[i]['LEVEL'] == 1) {
        if (this.newAssigneeList[i]['USER_ID'] == Number(this.cookie.get("userId"))) {
          this.TASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
          this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);

          currentCat = this.newAssigneeList[i]['TASK_CATEGORY_ID'];
          this.TASK_CATEGORY_ID = currentCat;
        }
      }

      // if (this.newAssigneeList[i]['LEVEL'] == 5) {
      //   if (this.newAssigneeList[i]['TASK_CATEGORY_ID'] == currentCat) {
      //     this.TASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      //     this.SUBTASK_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
      //   }
      // }
    }
  }

  loadModal() {
    this.getRoleProjectWise(this.data1.PROJECT_ID);
  }

  moduleList = [];

  loadAllModules() {
    sessionStorage.setItem("projectID", this.data1.PROJECT_ID.toString());

    if (this.ISSUE_TYPE == "M") {
      this.moduleDrawerVisible = true;

    } else if (this.ISSUE_TYPE == "F") {
      this.featureDrawerVisible = true;

    } else if (this.ISSUE_TYPE == "T") {
      this.taskDrawerVisible = true;

    } else if (this.ISSUE_TYPE == "S") {
      this.subtaskDrawerVisible = true;
    }

    this.moduleList = [];
    this.loadAllAssignee();

    // this.MODULE_ID = 0;
    // this.TASK_MODULE_ID = 0;
    // this.SUBTASK_MODULE_ID = 0;

    this.isFeatureModuleLoading = true;
    this.isTaskModuleLoading = true;
    this.isSubtaskModuleLoading = true;

    this.api.getAllModules(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and PROJECT_ID=' + this.data1.PROJECT_ID).subscribe(moduleData => {
      if (moduleData['code'] == 200) {

        this.isFeatureModuleLoading = false;
        this.isTaskModuleLoading = false;
        this.isSubtaskModuleLoading = false;
        this.moduleList = moduleData['data'];
      }

    }, err => {

    });
  }

  getRoleProjectWise(projectID) {
    this.api.getProjectDetails(projectID, 0).subscribe(data => {
      if (data['code'] == 200) {
        var roleData = data['data'];

        // var roleData1 = roleData.filter(obj => {
        //   return obj.USER_ID == this.api.userId
        // });

        // Get Level Role ID Wise
        this.levelVar = '1';
        // this.api.getAllRoles(0, 0, '', '', ' and ID=' + roleData[0]['ROLE_ID']).subscribe(data => {
        //   if (data['code'] == 200) {
        //     this.levelVar = data['data'][0]['LEVEL'];
        this.hideShowRadioButtons();
        //   }

        // }, err => {
        //   if (err['ok'] == false)
        //     this.notificationService.error("Server Not Found", "");
        // });
      }

    }, err => {

    });
  }



  fillTaskFeatureModuleWise(moduleID) {
    this.TASK_FEATURE_ID = 0;
    this.isTaskFeatureLoading = true;

    this.loadAllTaskFeatures(moduleID);
  }

  fillSubtaskFeatureModuleWise(moduleID) {
    this.SUBTASK_FEATURE_ID = 0;
    this.PARENT_TASK_ID = 0;
    this.isSubtaskFeatureLoading = true;

    this.loadAllSubtaskFeatures(moduleID);
  }

  taskFeatureList = [];
  loadAllTaskFeatures(moduleID) {
    this.taskFeatureList = [];

    this.api.getAllFeatures(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and MODULE_ID=' + moduleID).subscribe(featureData => {
      if (featureData['code'] == 200) {
        this.isTaskFeatureLoading = false;
        this.taskFeatureList = featureData['data'];
      }

    }, err => {

    });
  }

  subtaskFeatureList = [];
  loadAllSubtaskFeatures(moduleID) {
    this.subtaskFeatureList = [];

    this.api.getAllFeatures(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and MODULE_ID=' + moduleID).subscribe(featureData => {
      if (featureData['code'] == 200) {
        this.isSubtaskFeatureLoading = false;
        this.subtaskFeatureList = featureData['data'];
      }

    }, err => {

    });
  }

  categoryList = [];

  loadAllCategories() {
    this.categoryList = [];

    this.api.getAllCategories(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      if (categoryData['code'] == 200) {
        this.isTaskCategoryLoading = false;
        this.isSubtaskCategoryLoading = false;
        this.categoryList = categoryData['data'];

        this.TASK_CATEGORY_ID = 0;
        this.SUBTASK_CATEGORY_ID = 0;
        var USER_ID = this.api.userId;

        this.api.getAllUsers(0, 0, 'ID', 'desc', ' and ID=' + USER_ID).subscribe(userData => {
          this.TASK_CATEGORY_ID = userData['data'][0]['TASK_CATEGORY_ID'];
          this.SUBTASK_CATEGORY_ID = userData['data'][0]['TASK_CATEGORY_ID'];

        }, err => {

        });
      }

    }, err => {

    });
  }
  nodes = []
  fillTaskSubtaskFeatureWise(featureID) {
    this.PARENT_TASK_ID = 0;
    this.isSubtaskParentTaskLoading = true;
    this.loadAllParentTasks(featureID);
  }
  fillTaskSubtaskWise(event) {
    this.api.getMappingWiseKanbanView(2, this.data1.PROJECT_ID, this.api.userId).subscribe(data => {
      if (data['code'] == 200) {
        if (data['data'] != null) {
          this.nodes = JSON.parse(data['data']);
        }
      }

    }, err => {

    });
  }
  parentTaskList = [];
  loadAllParentTasks(featureID) {
    this.parentTaskList = [];

    this.api.getAllTaskSubtask(0, 0, 'ID', 'asc', ' and IS_ACTIVE=1 and PARENT_ID=0 and FEATURE_ID=' + featureID).subscribe(taskData => {
      if (taskData['code'] == 200) {
        this.isSubtaskParentTaskLoading = false;
        this.parentTaskList = taskData['data'];


      }

    }, err => {

    });
  }

  @ViewChild('moduleEndDatePicker') moduleEndDatePicker: NzDatePickerComponent;

  // moduleStartDateHandle(open: boolean) {
  //   this.MODULE_END_DATE = null;

  //   if (!open) {
  //     this.moduleEndDatePicker.open();
  //     this.MODULE_END_DATE = this.MODULE_START_DATE;
  //   }
  // }

  @ViewChild('featureEndDatePicker') featureEndDatePicker: NzDatePickerComponent;

  featureStartDateHandle(open: boolean) {
    this.FEATURE_END_DATE = null;

    if (!open) {
      this.featureEndDatePicker.open();
      this.FEATURE_END_DATE = this.FEATURE_START_DATE;
    }
  }

  @ViewChild('taskEndDatePicker') taskEndDatePicker: NzDatePickerComponent;

  taskStartDateHandle(open: boolean) {
    this.TASK_END_DATE = null;

    if (!open) {
      this.taskEndDatePicker.open();
      this.TASK_END_DATE = this.TASK_START_DATE;
    }
  }

  @ViewChild('subtaskEndDatePicker') subtaskEndDatePicker: NzDatePickerComponent;

  subtaskStartDateHandle(open: boolean) {
    this.SUBTASK_END_DATE = null;

    if (!open) {
      this.subtaskEndDatePicker.open();
      this.SUBTASK_END_DATE = this.SUBTASK_START_DATE;
    }
  }

  disabledModuleEndDate = (endValue: Date): boolean => {
    if (this.MODULE_START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var modulePreviousDate = new Date(this.MODULE_START_DATE);
      modulePreviousDate.setDate(modulePreviousDate.getDate() + (-1));

      return endValue <= new Date(modulePreviousDate);
    };
  }

  disabledFeatureEndDate = (endValue: Date): boolean => {
    if (this.FEATURE_START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var featurePreviousDate = new Date(this.FEATURE_START_DATE);
      featurePreviousDate.setDate(featurePreviousDate.getDate() + (-1));

      return endValue <= new Date(featurePreviousDate);
    };
  }

  disabledTaskEndDate = (endValue: Date): boolean => {
    if (this.TASK_START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var taskPreviousDate = new Date(this.TASK_START_DATE);
      taskPreviousDate.setDate(taskPreviousDate.getDate() + (-1));

      return endValue <= new Date(taskPreviousDate);
    };
  }

  disabledSubtaskEndDate = (endValue: Date): boolean => {
    if (this.SUBTASK_START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var subtaskPreviousDate = new Date(this.SUBTASK_START_DATE);
      subtaskPreviousDate.setDate(subtaskPreviousDate.getDate() + (-1));

      return endValue <= new Date(subtaskPreviousDate);
    };
  }

  generateBadge(nameForBadge: string) {
    return this.api.createBadge(nameForBadge);
  }
  today = this.ENQUIRY_DATE
  timeDefaultValue = setHours(new Date(), 0);

  disabledStartDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.ENQUIRY_DATE) > 0 || differenceInCalendarDays(current, this.ENQUIRY_DATE) < 0;


  // dates = ['2022-04-15', '2022-04-10', '2022-04-11', '2022-04-12', '2022-04-13', '2022-04-14'];
  dates = [];

  disabledEndDate = current => {
    let index = this.dates.findIndex(date => date === moment(current).format('YYYY-MM-DD'))
    return index === -1 && true
  }

  disabledDateTime: DisabledTimeFn = () => ({
    nzDisabledHours: () => [],
    nzDisabledMinutes: () => [],
    nzDisabledSeconds: () => []
  });

  startTimeInMilliseconds = 0;
  endTimeInMilliseconds = 0;
  tempStartDate: Date = null;

  sDateChange() {

    var startDate = new Date(this.data6.WORKED_DATETIME);


    startDate.setMilliseconds(0);
    startDate.setSeconds(0);

    this.startTimeInMilliseconds = startDate.getTime();


    if (this.startTimeInMilliseconds > 0) {
      this.dates = [];
      this.dates.push(this.datePipe.transform(this.data6.WORKED_DATETIME, "yyyy-MM-dd"));


      // 

      this.tempStartDate = new Date(this.data6.WORKED_DATETIME);


    } else {
      this.dates = [];


      this.tempStartDate = null;

    }
  }

  // getDaysArray(start, end) {
  //   for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
  //     arr.push(this.datePipe.transform(dt, "yyyy-MM-dd"));
  //   }
  //   return arr;
  // };

  eDateChange() {

    var endDate = new Date(this.data6.END_DATETIME);


    endDate.setMilliseconds(0);
    endDate.setSeconds(0);

    this.endTimeInMilliseconds = endDate.getTime();

  }

  startDateChange() {
    this.sDateChange();
  }

  endDateChange() {
    this.sDateChange();
    this.eDateChange();
    this.getDifference(this.startTimeInMilliseconds, this.endTimeInMilliseconds)
  }

  getDifference(startTime, endTime) {
    var Difference_In_Time = endTime - startTime;
    if (Difference_In_Time > 0) {
      var seconds = Math.floor((Difference_In_Time / 1000) % 60);
      var minutes = Math.floor((Difference_In_Time / (1000 * 60)) % 60);
      var hours = Math.floor((Difference_In_Time / (1000 * 60 * 60)) % 24);
      var days = Math.floor(Difference_In_Time / (1000 * 60 * 60 * 24));

      if (hours < 10) { hours = 0 + hours; }
      if (minutes < 10) { minutes = 0 + minutes; }
      if (seconds < 10) { seconds = 0 + seconds; }

      this.data6.SPENT_HOURS = (days * 24) + hours;
      this.data6.SPENT_MINUTES = minutes;
      this.data6.SPENT_SECONDS = seconds;

    } else {
      this.data6.SPENT_HOURS = 0;
      this.data6.SPENT_MINUTES = 0;
      this.data6.SPENT_SECONDS = 0;
    }
  }

  // @ViewChild('moduleEndDatePicker') moduleEndDatePicker: NzDatePickerComponent;

  moduleStartDateHandle(open: boolean) {
    if (!open) {
      this.moduleEndDatePicker.open();
    }
  }

  moduleEndDateHandle(open: boolean) {
    if (open) {
      if (this.tempStartDate != null) {
        this.data6.END_DATETIME = this.tempStartDate;
      }

      // if (this.data.WORKED_DATETIME != null || this.data.END_DATETIME != undefined) {
      //   this.data.END_DATETIME = this.data.WORKED_DATETIME;
      // }

      if (this.data6.END_DATETIME == null || this.data6.END_DATETIME == undefined) {
        this.data6.END_DATETIME = new Date();

      } else {
        this.data6.END_DATETIME = this.data6.END_DATETIME;
      }
    }



  }
}
